/**
 * Detect in-app / embedded browsers where OAuth redirect state is often lost
 * (sessionStorage partitioned or inaccessible), causing Firebase "missing initial state" errors.
 */
export const isInAppBrowser = () => {
  if (typeof navigator === "undefined" || !navigator.userAgent) return false;
  const ua = navigator.userAgent.toLowerCase();
  const inAppPatterns = [
    "telegram",
    "instagram",
    "fban", // Facebook app
    "fbav",
    "fb_iab", // Facebook in-app browser
    "line/",
    "twitter",
    "whatsapp",
    "snapchat",
    "kakaotalk",
    "naver",
    "daum",
    "wechat",
    "wv", // Android WebView (generic)
  ];
  return inAppPatterns.some((p) => ua.includes(p));
};
